// paywal-page页面相关逻辑配置项
const paypalPageConfig = {
        fitnessLevelLableName: "fitnessLevel",
        leveName: 'pilatesLevel',
        fitnessLevelOptionName: "fitnessLevelScreenOption",
};
export default paypalPageConfig